import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, Shield } from 'lucide-react';
export function Slide8_Investment() {
  return <SlideLayout data-id="element-236">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-237">
        <div className="space-y-6 text-center" data-id="element-238">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-239">
            Partnership Structure
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-240">
            Pricing reflects ownership and accountability — not effort or hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-241">
          {/* Build */}
          <motion.div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-242">
            <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-6 border border-slate-700" data-id="element-243">
              <Shield className="w-6 h-6 text-emerald-400" data-id="element-244" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-245">Build</h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-246">One-time setup</p>
            <p className="text-slate-500 text-sm" data-id="element-247">
              System architecture and initial setup
            </p>
          </motion.div>

          {/* System */}
          <motion.div className="bg-slate-900/40 border border-emerald-500/30 rounded-xl p-8 relative" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-248">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500 rounded-t-xl" data-id="element-249" />
            <div className="w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mb-6 border border-emerald-500/20" data-id="element-250">
              <DollarSign className="w-6 h-6 text-emerald-400" data-id="element-251" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-252">System</h3>
            <p className="text-emerald-400 text-sm mb-6" data-id="element-253">Monthly recurring</p>
            <p className="text-slate-500 text-sm" data-id="element-254">Per month + campaign costs</p>
          </motion.div>

          {/* Performance */}
          <motion.div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-255">
            <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-6 border border-slate-700" data-id="element-256">
              <TrendingUp className="w-6 h-6 text-amber-400" data-id="element-257" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-258">Performance</h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-259">Success-based</p>
            <p className="text-slate-500 text-sm" data-id="element-260">
              Per rep at 30/60/90 day milestones
            </p>
          </motion.div>
        </div>

        <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-xl p-6 max-w-3xl mx-auto" data-id="element-261">
          <p className="text-emerald-400 text-center font-medium" data-id="element-262">
            Performance bonuses align our success with yours. We only win when
            your reps succeed.
          </p>
        </div>
      </div>
    </SlideLayout>;
}